import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDriverAuth } from '../../context/DriverAuthContext';
import '../../DriverApp.css';

const API = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8002/api/v1/driver'
  : '/api/v1/driver';

export default function LoginPage() {
  const { saveLogin } = useDriverAuth();
  const nav = useNavigate();

  const [step,       setStep]       = useState('identify'); // identify | setpw | login
  const [identifier, setIdentifier] = useState('');
  const [driverInfo, setDriverInfo] = useState(null);
  const [password,   setPassword]   = useState('');
  const [nationalId, setNationalId] = useState('');
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState('');

  const handleIdentify = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API}/auth/identify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: identifier.trim() }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.detail || 'خطأ'); return; }
      setDriverInfo(data);
      setStep(data.has_password ? 'login' : 'setpw');
    } catch { setError('خطأ في الاتصال'); }
    finally   { setLoading(false); }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: identifier.trim(), password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.detail || 'بيانات غير صحيحة'); return; }
      saveLogin(data, data.driver);
      nav('/driver/home', { replace: true });
    } catch { setError('خطأ في الاتصال'); }
    finally   { setLoading(false); }
  };

  const handleSetPw = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API}/auth/set-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: identifier.trim(), national_id: nationalId.trim(), password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.detail || 'خطأ'); return; }
      saveLogin(data, data.driver);
      nav('/driver/home', { replace: true });
    } catch { setError('خطأ في الاتصال'); }
    finally   { setLoading(false); }
  };

  return (
    <div className="drv-auth">
      <div className="drv-auth__logo">
        <svg viewBox="0 0 40 40" fill="none">
          <circle cx="20" cy="20" r="20" fill="#3b82f6"/>
          <path d="M20 8 C14 14 10 18 10 23 a10 10 0 0 0 20 0 C30 18 26 14 20 8Z" fill="white"/>
        </svg>
        <div>
          <span>Watrly</span>
          <small style={{display:'block'}}>بوابة السائق</small>
        </div>
      </div>

      <div className="drv-auth__card">
        {step === 'identify' && (
          <>
            <h2>مرحباً بك 👋</h2>
            <p>أدخل رقم جوالك أو رقم هويتك للمتابعة</p>
            <form onSubmit={handleIdentify}>
              <div className="drv-field">
                <label>رقم الجوال أو رقم الهوية</label>
                <input
                  dir="ltr"
                  value={identifier}
                  onChange={e => setIdentifier(e.target.value)}
                  placeholder="05XXXXXXXX  أو  1XXXXXXXXX"
                  required
                />
              </div>
              {error && <p className="drv-error">{error}</p>}
              <button className="drv-btn drv-btn--primary" disabled={loading}>
                {loading ? <span className="drv-spinner drv-spinner--sm"/> : 'متابعة ←'}
              </button>
            </form>
            <div style={{marginTop:20, textAlign:'center'}}>
              <Link to="/register" className="drv-link">سجّل كسائق جديد</Link>
            </div>
          </>
        )}

        {step === 'login' && driverInfo && (
          <>
            <div style={{display:'flex', alignItems:'center', gap:12, marginBottom:20}}>
              <div className="drv-profile__avatar" style={{width:50,height:50,fontSize:20,margin:0}}>
                {(driverInfo.full_name || '?')[0]}
              </div>
              <div>
                <div style={{fontWeight:700}}>{driverInfo.full_name}</div>
                <div style={{fontSize:13, color:'var(--drv-text2)'}}>أدخل كلمة المرور</div>
              </div>
            </div>
            <form onSubmit={handleLogin}>
              <div className="drv-field">
                <label>كلمة المرور</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
              </div>
              {error && <p className="drv-error">{error}</p>}
              <button className="drv-btn drv-btn--primary" disabled={loading}>
                {loading ? <span className="drv-spinner drv-spinner--sm"/> : 'تسجيل الدخول'}
              </button>
            </form>
            <button onClick={() => { setStep('identify'); setError(''); }} style={{background:'none',border:'none',color:'var(--drv-text2)',fontSize:13,cursor:'pointer',marginTop:14,width:'100%'}}>
              ← تغيير الرقم
            </button>
          </>
        )}

        {step === 'setpw' && driverInfo && (
          <>
            <h2>إنشاء كلمة مرور 🔐</h2>
            <p>مرحباً {driverInfo.full_name}! أنشئ كلمة مرور لحسابك</p>
            <form onSubmit={handleSetPw}>
              <div className="drv-field">
                <label>رقم الهوية الوطنية (للتحقق)</label>
                <input
                  dir="ltr"
                  value={nationalId}
                  onChange={e => setNationalId(e.target.value)}
                  placeholder="1XXXXXXXXX"
                  required
                />
              </div>
              <div className="drv-field">
                <label>كلمة المرور الجديدة</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="6 أحرف على الأقل"
                  minLength={6}
                  required
                />
              </div>
              {error && <p className="drv-error">{error}</p>}
              <button className="drv-btn drv-btn--primary" disabled={loading}>
                {loading ? <span className="drv-spinner drv-spinner--sm"/> : 'حفظ وتسجيل الدخول'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
